export const ISRESULT = 'ISRESULT';
//Layout
export const GET_DATA_LAYOUT_LAYOUT = 'GET_DATA_LAYOUT_LAYOUT';
export const GET_DATA_LAYOUT_LAYOUT_SUCCEEDED = 'GET_DATA_LAYOUT_LAYOUT_SUCCEEDED';
export const REQUERT_LAYOUT_LAYOUT_FAILED = 'REQUERT_LAYOUT_LAYOUT_FAILED';
export const SET_DATA_LAYOUT_LAYOUT = 'SET_DATA_LAYOUT_LAYOUT';
//Noti
export const GET_DATA_Notification = 'GET_DATA_Notification';
export const GET_DATA_Notification_SUCCEEDED = 'GET_DATA_Notification_SUCCEEDED';
export const REQUERT_Notification_FAILED = 'REQUERT_Notification_FAILED';
export const SET_DATA_Notification = 'SET_DATA_Notification';
export const UPDATE_DATA_NOTIFICATION = 'UPDATE_DATA_NOTIFICATION';
//logout
export const SET_DATA_LOGOUT = 'SET_DATA_LOGOUT';
export const REQUERT_SET_DATA_LOGOUT_FAILED = 'REQUERT_SET_DATA_LOGOUT_FAILED';
export const GET_DATA_LOGOUT_SUCCEEDED = 'GET_DATA_LOGOUT_SUCCEEDED';

//IndexHygen